/**
 * @generated SignedSource<<1c98613a79720b082a6acdc4655d9b08>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type usePermissionCanEditPipelineGetParentProjectIdQuery$variables = {
  pipelineLocator: string;
};
export type usePermissionCanEditPipelineGetParentProjectIdQuery$data = {
  readonly pipeline: {
    readonly parentProject: {
      readonly id: Branded<string, 'ProjectId'> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type usePermissionCanEditPipelineGetParentProjectIdQuery = {
  response: usePermissionCanEditPipelineGetParentProjectIdQuery$data;
  variables: usePermissionCanEditPipelineGetParentProjectIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pipelineLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pipelineLocator",
    "variableName": "pipelineLocator"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "usePermissionCanEditPipelineGetParentProjectIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "usePermissionCanEditPipelineGetParentProjectIdQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineRest",
        "kind": "LinkedField",
        "name": "pipeline",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectRest",
            "kind": "LinkedField",
            "name": "parentProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "014e70cc80c754425fa274075163cff9",
    "id": null,
    "metadata": {},
    "name": "usePermissionCanEditPipelineGetParentProjectIdQuery",
    "operationKind": "query",
    "text": "query usePermissionCanEditPipelineGetParentProjectIdQuery(\n  $pipelineLocator: String!\n) {\n  pipeline(pipelineLocator: $pipelineLocator) {\n    parentProject {\n      id\n      _id\n    }\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "87c4f8d31ffde2b3aa00144f611e246b";

export default node;
